var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconNews(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1139_3639)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.3333 7.99967H25.3333C25.6869 7.99967 26.0261 8.14015 26.2761 8.3902C26.5262 8.64025 26.6666 8.97939 26.6666 9.33301V23.9997C26.6666 24.7069 26.3857 25.3852 25.8856 25.8853C25.3855 26.3854 24.7072 26.6663 24 26.6663C23.2927 26.6663 22.6145 26.3854 22.1144 25.8853C21.6143 25.3852 21.3333 24.7069 21.3333 23.9997V6.66634C21.3333 6.31272 21.1928 5.97358 20.9428 5.72353C20.6927 5.47348 20.3536 5.33301 20 5.33301H6.66665C6.31302 5.33301 5.97389 5.47348 5.72384 5.72353C5.47379 5.97358 5.33331 6.31272 5.33331 6.66634V22.6663C5.33331 23.7272 5.75474 24.7446 6.50489 25.4948C7.25503 26.2449 8.27245 26.6663 9.33331 26.6663H24",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6667 10.667H16",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6667 16H16",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6667 21.333H16",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1139_3639"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNews);
export default __webpack_public_path__ + "static/media/icon-news.0a5924b1bddd0e97fcad76e51ef331e1.svg";
export { ForwardRef as ReactComponent };